<template>
  <div class="order-list">
    <div class="form-block">
      <el-form ref="form" :model="searchForm" label-width="80px" :inline="true">
        <el-form-item class="type-form-item" style="width: 90%" label="查询类型">
          <div class="search-type-btn">
            <div class="type-btn" v-for="btn in searchTypes" :class="{ 'active': searchType == btn.value }" @click="searchType = btn.value" :key="btn.value">{{ btn.label }}</div>
          </div>
        </el-form-item>
        <el-form-item label="退单状态" v-show="searchType == 1">
          <el-select v-model="searchForm.refundState" placeholder="请选择">
            <el-option v-for="item in refundStates" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单类型" v-show="searchType == 1">
          <el-select v-model="searchForm.type" placeholder="请选择">
            <el-option v-for="item in orderTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" v-show="searchType == 1">
          <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="审核时间" v-show="searchType == 1">
          <el-date-picker v-model="refundTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="所属应用" v-show="searchType == 1">
          <el-input v-model.trim="searchForm.appName" @keyup.native.enter="search" class="dim-search-input" placeholder="请输入应用名称"></el-input>
        </el-form-item>
        <el-form-item label="所属套餐" v-show="searchType == 1">
          <el-input v-model.trim="searchForm.packageKey" @keyup.native.enter="search" class="dim-search-input" placeholder="请输入套餐名称/SKU"></el-input>
        </el-form-item>
        <el-form-item label v-show="searchType == 2">
          <el-input v-model.trim="searchForm.noKey" class="search-input" prefix-icon="el-icon-search" @keyup.native.enter="search" placeholder="请输入详细的交易原单号/退款单号"></el-input>
        </el-form-item>
        <el-form-item label>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="down-block" @click="downloadList">
        <img src="../../assets/img/order-download.svg" alt />
        下载退款单
      </div>
    </div>
    <div class="table-block">
      <new-table :data="tableData" :columns="columns" :pages="pages"></new-table>
    </div>
    <export-tip ref="exportTip" />
  </div>
</template>

<script>
import orderService from "../../apis/orderService";
import { OrderType, OrderTypeLabel, RefundState, RefundStateLabel } from "../../service/enum";
import { dateFormat } from "../../utils/util";
import newTable from "../../components/new-table"

export default {
  name: "order-list",
  data() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);

    return {
      pages: {
        props: {
          "page-size": 20,
          "current-page": 1,
          "total": 0,
          "page-sizes": [10, 20, 50, 100],
        },
        on: {
          "current-change": (p) => {
            this.handleCurrentChange(p)
          },
          "size-change": (p) => {
            this.sizesChange(p)
          }
        }
      },
      searchTypes: [
        { label: "模糊查询", value: 1 },
        { label: "精确查询", value: 2 },
      ],
      refundStates: [
        { label: RefundStateLabel[RefundState.all], value: RefundState.all },
        { label: RefundStateLabel[RefundState.approving], value: RefundState.approving },
        { label: RefundStateLabel[RefundState.pass], value: RefundState.pass },
        { label: RefundStateLabel[RefundState.fail], value: RefundState.fail },
      ],
      orderTypes: [
        { label: OrderTypeLabel[OrderType.all], value: OrderType.all },
        { label: OrderTypeLabel[OrderType.buy], value: OrderType.buy },
        { label: OrderTypeLabel[OrderType.renew], value: OrderType.renew },
        { label: OrderTypeLabel[OrderType.upgrade], value: OrderType.upgrade }
      ],
      date: [dateFormat(start), dateFormat(end)],
      refundTime: ["", ""],
      searchType: 1,//查询类型
      searchForm: {
        refundState: RefundState.all,//订单状态
        type: OrderType.all,//订单类型
        noKey: "",//精准查找单号
        appName: "",//所属应用
        packageKey: "",//所属套餐
      },
      tableData: [],
      columns: [
        { label: "退款单号", prop: "refundNo", "min-width": "160px" },
        { label: "原单号", prop: "orderNo", "min-width": "160px" },
        { label: "应用名称", prop: "appName", "min-width": "120px" },
        { label: "SKU", prop: "packageSku", "min-width": "100px" },
        { label: "套餐名称", prop: "packageName", "min-width": "120" },
        {
          label: "原单类型", "min-width": '90px',
          render: (h, scope) => {
            return (
              <div>
                <span>{OrderTypeLabel[scope.row.type.toString()]}</span>
              </div>
            )
          }
        },
        {
          label: "退款金额", prop: "applyMoney", "min-width": '90px',
          render: (h, scope) => {
            return (
              <div>
                <span>{orderService.toYuan(scope.row.applyMoney)}</span>
              </div>
            )
          }
        },
        {
          label: "实退金额", prop: "actualMoney", "min-width": '90px',
          render: (h, scope) => {
            return (
              <div>
                <span>{orderService.toYuan(scope.row.actualMoney)}</span>
              </div>
            )
          }
        },
        {
          label: "用户姓名", prop: "maxUsers", "min-width": '90px',
          render: (h, scope) => {
            return (
              <div>
                <span>{(scope.row.refundUserInfo || {}).realName}</span>
              </div>
            )
          }
        }, {
          label: "采购企业", prop: "buyComp", "min-width": '180px',
          render: (h, scope) => {
            return (
              <div>
                <span>{(scope.row.refundUserInfo || {}).compName}</span>
              </div>
            )
          }
        },
        {
          label: "提交时间", prop: "creationTime", "min-width": '150px'
        },
        {
          label: "审核时间", prop: "refundTime", "min-width": '150px'
        },
        {
          label: "退款状态", prop: "maxUsers", "min-width": '90px',
          render: (h, scope) => {
            return (
              <div>
                <span>{RefundStateLabel[scope.row.refundState]}</span>
              </div>
            )
          }
        },
        {
          label: "操作", "min-width": "100",
          render: (h, scope) => {
            return (
              <div>
                <el-button type="text" size="small" on={{
                  "click": () => {
                    this.orderInfo(scope.row, scope.$index)
                  }
                }}>
                  {this.getHandlerText(scope.row)}
                </el-button>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    orderInfo(row) {
      this.$router.push({ path: '/refund-list/refund-details?orderNo=' + row.orderNo })
    },
    async getList() {
      this.postData.pageIndex = this.pages.props["current-page"];
      this.postData.pageSize = this.pages.props["page-size"];
      const res = await orderService.getRefundList(this.postData);
      this.pages.props.total = res.dataCount;
      this.tableData = res.data;
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getList();
    },
    handleCurrentChange(pageIndex) {
      this.pages.props["current-page"] = pageIndex;
      this.getList();
    },
    search() {
      this.pages.props["current-page"] = 1;
      this.getList();
    },
    downloadList() {
      orderService.downloadRefundList(this.postData);
      this.$refs.exportTip.open();
    },
    getHandlerText(row) {
      switch (row.refundState.toString()) {
        case RefundState.approving:
          return "审核";
        case RefundState.fail:
        case RefundState.pass:
          return "详情";
      }
    }
  },

  computed: {
    postData() {
      return this.searchType == 2 ? {
        noKey: this.searchForm.noKey,
      } : {
        ...this.searchForm,
        noKey: "",
        beginTime: this.date ? this.date[0] : "",
        endTime: this.date ? this.date[1] : "",
        refundBeginTime: this.refundTime ? this.refundTime[0] : "",
        refundEndTime: this.refundTime ? this.refundTime[1] : "",
      }
    }
  },
  mounted() {
    this.getList();
  },
  components: { newTable }
}
</script>

<style scoped lang="scss">
.order-list {
  display: flex;
  flex-direction: column;
  .form-block {
    position: relative;
    padding-bottom: 6px;
    .el-form--inline .el-form-item {
      margin-right: 30px;
      margin-bottom: 10px;
      .search-input {
        width: 320px;
      }
      .dim-search-input {
        width: 180px;
      }
      .el-button--small,
      .el-button--small.is-round {
        padding: 11px 41px;
      }
      .el-form-item__content {
        line-height: 36px;
      }
      .el-select {
        width: 180px;
      }
      .el-range-editor--small.el-input__inner {
        width: 240px;
      }
      .el-date-editor.el-date-editor--date {
        width: 154px;
      }
    }
    ::v-deep .el-form-item__label {
      padding-right: 0;
      text-align: left;
    }
    .type-form-item {
      ::v-deep .el-form-item__label {
        font-size: 16px;
      }
      .search-type-btn {
        line-height: 34px;
        font-size: 12px;
        display: flex;
        overflow: hidden;
        .type-btn {
          width: 113px;
          border: 1px solid #d1d1d1;
          text-align: center;
          color: #999;
          border-radius: 5px;
          position: relative;
          cursor: pointer;
          &:last-of-type {
            margin-left: -6px;
          }
          &.active {
            border-color: #1890ff;
            background-color: #1890ff;
            color: #fff;
            z-index: 1;
          }
        }
      }
    }
    .down-block {
      position: absolute;
      bottom: 18px;
      right: 13px;
      display: flex;
      font-size: 12px;
      color: #1890ff;
      cursor: pointer;
    }
  }
  .table-block {
    flex: 1;
    overflow: auto;
    ::v-deep .row-header {
      height: 36px;
      line-height: 36px;
      th,
      tr {
        background-color: #fafafa;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
  .page {
    padding-top: 6px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
